import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    de: {
        translation: translationDE
    }
};

// Check if country is Germany to default to German
const getDefaultLanguage = () => {
    const countryName = Cookies.get('x-countryname');
    if (countryName && countryName.toLowerCase() === 'germany') {
        return 'de';
    }
    return 'en';
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: getDefaultLanguage(),
        lng: localStorage.getItem('i18nextLng') || getDefaultLanguage(),
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage']
        }
    });

export default i18n;
